import { useLocation } from "react-router-dom";
import { InlineNotice } from "../components/Feedback/InlineNotice";
import { PageHeader } from "../components/PageHeader/PageHeader";
import { Panel } from "../components/Panel/Panel";
import { legacyPathFor } from "../navigation/navigation";
import styles from "./MigrationPlaceholderPage.module.css";

interface MigrationPlaceholderPageProps {
  screen: string;
}

export function MigrationPlaceholderPage({ screen }: MigrationPlaceholderPageProps) {
  const location = useLocation();
  return (
    <div className={styles.page}>
      <PageHeader
        eyebrow="React migration preview"
        title={`${screen} foundation`}
        description="The application shell and shared design-system boundary are running in React. This product screen still uses the verified vanilla implementation until its parity milestone is complete."
        actions={<a className={styles.legacyLink} href={legacyPathFor(location.pathname)}>Open current {screen}</a>}
      />
      <InlineNotice title="No cutover has occurred">
        The current CRM remains authoritative for this screen. The React preview is isolated under /react/ and uses the same backend contracts.
      </InlineNotice>
      <div className={styles.grid}>
        <Panel>
          <span className={styles.kicker}>Identity</span>
          <strong>Existing session context</strong>
          <p>The shell reuses the current token and loads the same user, tenant, options, and team boundaries.</p>
        </Panel>
        <Panel>
          <span className={styles.kicker}>Permissions</span>
          <strong>Role-aware navigation</strong>
          <p>Owner, manager, staff, and super-admin destinations match the current CRM navigation contract.</p>
        </Panel>
        <Panel>
          <span className={styles.kicker}>Delivery</span>
          <strong>Parallel same-domain build</strong>
          <p>The React bundle is served separately while the vanilla frontend remains available as the rollback surface.</p>
        </Panel>
      </div>
    </div>
  );
}
